import { Message } from "@/models/message.model"
import { type IMessage } from "@/interfaces/api/message.interface"
import { MessageRepository } from "@/repositories/message-repository"
import { useMessageStore } from "@/store/messages.store"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"

export class MessageController extends GenericModelController<
  Message,
  IMessage,
  MessageRepository
> {
  constructor() {
    const { pushToRelatedObjects, removeFromRelatedObjects } = useMessageStore()
    const storeFunctionsConfig = {
      onCreate: pushToRelatedObjects,
      onDelete: removeFromRelatedObjects
    }

    super(Message, storeFunctionsConfig, new MessageRepository())
  }
}
